__turbopack_context__.v({
  "search__item": "SearchItem-module-scss-module__9MTsQG__search__item",
});
